import cn from 'classnames';
import React, { FC } from 'react';

import { Bars } from '@.partials';
import { CreateTooltipDataFn } from '@/Components/Partials/Charts/Bars/types';
import { CustomerWizardStepsDatasetValue } from '@/Types/analytics';

import { BAR_FACTOR, MINI_TOP_STEP_VALUE, TOP_STEP_VALUE } from '../FavoriteHeartChart/constants';
import S from './styles.module.scss';

type CustomersWizardStepsChartProps = {
    data: CustomerWizardStepsDatasetValue[];
    mini?: boolean;
};

export const CustomersWizardStepsChart: FC<CustomersWizardStepsChartProps> = ({ data, mini = false }) => {
    const createTooltipData: CreateTooltipDataFn<CustomerWizardStepsDatasetValue> = (data) => ({
        title: data.label,
        value: data.value,
        name: data.question,
    });

    const stepValue = mini ? MINI_TOP_STEP_VALUE : TOP_STEP_VALUE;

    const height = data.length * stepValue * BAR_FACTOR;

    return (
        <div className={cn(S.customers_and_wizard_steps, { [S['customers_and_wizard_steps-mini']]: mini })}>
            <h3 className={cn(S.title, { [S['title-mini']]: mini })}>Customers and Wizard steps</h3>
            <Bars data={data} height={height} isHorizontal createTooltipData={createTooltipData} axisDataName="Steps" isHideFractionalTicks mini={mini} />
        </div>
    );
};
